import { createSlice } from "@reduxjs/toolkit";
import {
  adminConfigurationDataAction,
  getConfigurationAction,
  getExportDataAction,
  searchBusinessAction,
} from "../actions";

export interface ISearchBusiness {
  name: string;
  formatted_address: string;
  place_id: string;
  location: {
    lat: number;
    lng: number;
  };
}
export interface IExportData {
  business_name: string;
  keyword: string;
  "Last Scan Date": string;
  "Avg. rank": number;
  longitude: number;
  latitude: number;
  address: string;
  "Crawl frequency (days)": number;
  pin_count: number;
  spacing: number;
  good_pins: number;
  medium_pins: number;
  bad_pins: number;
  not_ranking_pins: number;
  marketShare: number | string;
  reviews: number;
  rating: number;
  google_url: string;
  "Place id": string;
  website_url: string;
}

export interface IConfigurationData {
  grid: {
    value: number;
    enabled: boolean;
  };
  radius: {
    value: number;
    enabled: boolean;
  };
  refresh: {
    frequency: string;
    refresh_every: number;
    enabled: boolean;
  };
  refresh_hour: {
    value: string;
    enabled: boolean;
  };
  _id: string;
  grid_array: { [key: string]: number } | any;
  costPer100Credits: number;
  costPer100AiCredits: number;
  costPerAiCall: number;
  originalCostPerAiCall?: number;
  originalCostPer100AiCredits?: number;
  freeScans: number;
  per_pin_cost: number;
  redirect_url: string;
  privacyPolicyUrl?: string;
  termsOfConditionUrl?: string;
  public_reward_type: string;
  setup_call_header?: string;
  setup_call_description?: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
}

interface IHelperState {
  searchBusinessData: ISearchBusiness[];
  searchBusinessLoading: boolean;
  exportData: IExportData[];
  exportDataLoading: boolean;
  configurationData: IConfigurationData[] | any;
  configurationDataLoading: boolean;
  isCompetitorSidepanelOpen: boolean;
  keyConfigurationData: any;
}

const initialState: IHelperState = {
  searchBusinessData: [],
  searchBusinessLoading: false,
  exportData: [],
  exportDataLoading: false,
  configurationData: [],
  configurationDataLoading: false,
  isCompetitorSidepanelOpen: false,
  keyConfigurationData: null,
};

const helperSlice = createSlice({
  name: "helper",
  initialState,
  reducers: {
    setIsCompetitorSidepanelOpen: (state, action) => {
      state.isCompetitorSidepanelOpen = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder

      //search business
      .addCase(searchBusinessAction.fulfilled, (state, action) => {
        state.searchBusinessLoading = false;
        state.searchBusinessData = action.payload.data;
      })

      //export business
      .addCase(getExportDataAction.pending, (state, action) => {
        state.exportDataLoading = true;
      })
      .addCase(getExportDataAction.fulfilled, (state, action) => {
        state.exportDataLoading = false;
        state.exportData = action.payload.data;
      })
      .addCase(getExportDataAction.rejected, (state, action) => {
        state.exportDataLoading = false;
      })

      //get configuration
      .addCase(getConfigurationAction.fulfilled, (state, action) => {
        state.configurationDataLoading = false;
        state.configurationData = action.payload.data;
      })

      .addCase(adminConfigurationDataAction.fulfilled, (state, action) => {
        state.configurationDataLoading = false;
        state.configurationData = action.payload?.data?.config;
        state.keyConfigurationData = action.payload?.data?.key;
      });
  },
});

export const { setIsCompetitorSidepanelOpen } = helperSlice.actions;
export default helperSlice.reducer;
